<div class="tabs-container" *ngIf="loggedInUserRole != 'HR Admin'">
  <ion-row *ngIf="!router.url.includes('Setup')  ">
    <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
      <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
        <mat-tab-group #tabGroup class="pt-10 pr-10" (selectedTabChange)="tabTypeChanged($event)">

          <mat-tab label="MyAssetReport"
            *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  person
                </span>My Asset Report</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="MyDeptReport"
            *ngIf=" (authorityNameCheck || loggedInUserRole == 'Manager') && !(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' ||loggedInUserRole=='Employee')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>My Dept Report </span>
            </ng-template>
          </mat-tab>
        
        </mat-tab-group>
      </div>
    </ion-col>
  </ion-row>
  <div class="card">
  </div>
</div>
<div class="container">
  <ion-row>
    <ion-col size="2" class="mt-10">
      <div class="formLabelRegularfs16 mb-5">
        Year<span class="red-cl">&nbsp;*</span>
      </div>
      <mat-form-field class="w-100 mat-height40 mat-input-style">
        <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"(selectionChange)="changeYear(selectedYearForCompetency)">
          <mat-option [value]="item.year" *ngFor="let item of pmsYears">
            {{sharedService.transformYearToFyFormat(item.year)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ion-col>

   
    <ion-col size="2" *ngIf="loggedInUserRole == 'HR Admin'||(authorityNameCheck &&selectedTypeTabName == 'MyDeptReport' )"class="mt-10">
      <div class="formLabelRegularfs16  mb-5">
        Select Dept
      </div>

      <ng-multiselect-dropdown  [placeholder]="'Select Dept'" [settings]="dropdownSettings"
      [data]="getDeptList" [(ngModel)]="selectedDep" (onSelect)="onSelectDepartment()"
      (onDeSelect)="onDeSelectDepartment()" (onSelectAll)="selectAllDepartment($event)"
      (onDeSelectAll)="onDeSelectAllDepartment()">
    </ng-multiselect-dropdown>
    </ion-col>

    <ion-col size="2" *ngIf="loggedInUserRole == 'HR Admin'||(authorityNameCheck &&selectedTypeTabName == 'MyDeptReport' )"class="mt-10">
      <div class="formLabelRegularfs16  mb-5">
            Select Employee
          </div>
    
     
      <ng-multiselect-dropdown [placeholder]="'Select Employee'" [settings]="dropdownSettings"
      [data]="getEmployeeList" [(ngModel)]="selectedEmployee" (onSelect)="onSelectEmployee()"
      (onDeSelect)="onDeSelectEmployee()" (onSelectAll)="SelectALLEmployee($event)"
      (onDeSelectAll)="onDeSelectALLEmployee()">
    </ng-multiselect-dropdown>
    </ion-col>
 
    <!-- <ion-col size="2" *ngIf="loggedInUserRole == 'HR Admin'||(authorityNameCheck &&selectedTypeTabName == 'MyDeptReport' )"class="mt-10">
      <div class="formLabelRegularfs16  mb-5">
      Select Band
    </div>


      <ng-multiselect-dropdown 
    
      [placeholder]="'Select Band'"
      [settings]="dropdownSettings"
      [data]="getBandList" 
      [(ngModel)]="selectedBand"
      (onSelect)="onSelectBand()"
      (onDeSelect)="onDeSelectBand()"
      (onSelectAll)="selectAllBands($event)"
      (onDeSelectAll)="onDeSelectAllBands()">
    </ng-multiselect-dropdown>
    
    </ion-col> -->




  </ion-row>

  <ion-row>


    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
      <mat-form-field class="mat-height40 mat-input-style" style="margin-left: 20px;">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterAssets(searchTerm);">
        <!-- <input [(ngModel)]="searchTerm" type="text" placeholder="Search Users" class="form-control mb-3" /> -->

      </mat-form-field>
    </ion-col>

    <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
      <div class="d-flex justify-content-flex-end ">

        <div>
          <label>
            <ion-label class="fs-14 font_regular pr-10 black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select"(selectionChange)="DislaySelectedRecord($event)">
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
          </label>
        </div>
        <mat-form-field class="w250 mat mat-height40 mat-input-style mr-15">
          <mat-date-range-input [rangePicker]="fromToDateDashboard">
            <input matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate"
              (dateChange)="onDateChangeDashboard()">
            <input matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate"
              (dateChange)="onDateChangeDashboard()">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboard"></mat-datepicker-toggle>
          <mat-date-range-picker #fromToDateDashboard></mat-date-range-picker>
        </mat-form-field>


        <div class="d-flex" style="margin-right: 15px;">
          <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="downloadExcel()">download</span>
        </div>
      </div>
    </ion-col>
  </ion-row>


  <!------------------------------------------------------- HR Login ------------------------------------------------>

  <div class="card  employeeTab">

    <div class="p-10" *ngIf="loggedInUserRole == 'HR Admin'">

      <div style="margin: 20px !important;">


        <div class="table-container">

          <table class="custom-table rounded-header">

            <thead>
              <tr>
             
                <th *ngFor="let item of nestedHeaders" class="fs-14 font_bold cl-black">
                  <div class="p-5 verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                    <!-- <span class="red-cl">&nbsp;*</span> -->
                    <div class="d-flex flex-column ml-10">
                      <i (click)="onSortAssending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                    <i (click)="onSortDesending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of assetAllocationFromAuthority; let rowId = index">

                <td>{{ row.assetName || '-' }}</td>
                <td>{{ row.employeeName || '-' }}</td>
                <td>{{ row.band || '-' }}</td>
                <td>{{ row.authorityDepartment || '-' }}</td>
                <td>{{ row.authorityName || '-' }}</td>
                <td>{{ row.dateOfAllocation | date: 'dd-MM-yyyy' || '-' }}</td>
                <td>
                  <textarea  rows="2" cols="4"
                  class="edittextarea"  [(ngModel)]=" row.currentAssetDescription"
                  maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
                </td>
                <td>{{ row.employeeAssetStatus || '-' }}</td>
                <td>
                  <textarea  rows="2" cols="4"
                  class="edittextarea"  [(ngModel)]="row.employeeComment"
                  maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
                </td>
                <td>{{ row.employeeCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
                <td>
                  <textarea  rows="2" cols="4"
                  class="edittextarea"  [(ngModel)]=" row.authorityDepartmentComment"
                  maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
                </td>
                <td>{{ row.authorityCommentDate |  date: 'dd-MM-yyyy' || '-' }}</td>
                <td>{{ row.assetRepairTime || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--   (onAssetNameClickInside)="employeeAsset($event)" -->
      </div>
    </div>
  </div>
  <!-- ---------------------------------------------------------Employee-------------------------------------------------------------------- -->

  <div class="card  employeeTab" *ngIf="selectedTypeTabName =='MyAssetReport' && loggedInUserRole != 'HR Admin'">

    <div class="card-body">
      <div>

        <div class="p-10">

          <div class="table-container">

            <table class="custom-table rounded-header">
    
              <thead>
                <tr>
               
                  <th *ngFor="let item of nestedHeaders" class="fs-14 font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style">
                      {{ item?.label }}
                      <!-- <span class="red-cl">&nbsp;*</span> -->
                      <div class="d-flex flex-column ml-10">
                        <i (click)="onSortAssending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                      <i (click)="onSortDesending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of assetAllocationFromAuthority; let rowId = index">
    
                  <td>{{ row.assetName || '-' }}</td>
                  <td>{{ row.employeeName || '-' }}</td>
                  <td>{{ row.band || '-' }}</td>
                  <td>{{ row.authorityDepartment || '-' }}</td>
                  <td>{{ row.authorityName || '-' }}</td>
                  <td>{{ row.dateOfAllocation | date: 'dd-MM-yyyy' || '-' }}</td>
                  <td>
                    <textarea  rows="2" cols="4"
                    class="edittextarea"  [(ngModel)]=" row.currentAssetDescription"
                    maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
                  </td>
                  <td>{{ row.employeeAssetStatus || '-' }}</td>
                  <td>
                    <textarea  rows="2" cols="4"
                    class="edittextarea"  [(ngModel)]="row.employeeComment"
                    maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
                  </td>
                  <td>{{ row.employeeCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
                  <td>
                    {{row.authorityDepartmentComment}}
                    <!-- <textarea  rows="2" cols="4"
                    class="edittextarea"  [(ngModel)]=" row.authorityDepartmentComment"
                    maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea> -->
                  </td>
                  <td>{{ row.authorityCommentDate |  date: 'dd-MM-yyyy' || '-' }}</td>
                  <td>{{ row.assetRepairTime || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-10" style="font-weight: bold;">
            <!-- {{tableDataDetails.length}} entries -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-------------------------------------------------------Manager Login ------------------------------------------------>

  <div class="card  employeeTab">

    <div class="p-10" *ngIf="selectedTypeTabName=='MyDeptReport'">

      <div class="table-container">

        <table class="custom-table rounded-header">

          <thead>
            <tr>
           
              <th *ngFor="let item of nestedHeaders" class="fs-14 font_bold cl-black">
                <div class="p-5 verticle-center justify-content-space-between icon-style">
                  {{ item?.label }}
                  <!-- <span class="red-cl">&nbsp;*</span> -->
                  <div class="d-flex flex-column ml-10">
                    <i (click)="onSortAssending(item.sortingName)"
                    class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                  <i (click)="onSortDesending(item.sortingName)"
                    class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of assetAllocationFromAuthority; let rowId = index">

              <td>{{ row.assetName || '-' }}</td>
              <td>{{ row.employeeName || '-' }}</td>
              <td>{{ row.band || '-' }}</td>
              <td>{{ row.authorityDepartment || '-' }}</td>
              <td>{{ row.authorityName || '-' }}</td>
              <td>{{ row.dateOfAllocation | date: 'dd-MM-yyyy' || '-' }}</td>
              <td>
                <textarea  rows="2" cols="4"
                class="edittextarea"  [(ngModel)]=" row.currentAssetDescription"
                maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
              </td>
              <td>{{ row.employeeAssetStatus || '-' }}</td>
              <td>
                <textarea  rows="2" cols="4"
                class="edittextarea"  [(ngModel)]="row.employeeComment"
                maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
              </td>
              <td>{{ row.employeeCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
              <td>
                {{row.authorityDepartmentComment}}
                <!-- <textarea  rows="2" cols="4"
                class="edittextarea"  [(ngModel)]=" row.authorityDepartmentComment"
                maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea> -->
              </td>
              <td>{{ row.authorityCommentDate |  date: 'dd-MM-yyyy' || '-' }}</td>
              <td>{{ row.assetRepairTime || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-10" style="font-weight: bold;">
        <!-- {{allTeamReimbursement.length}} entries -->
      </div>
    </div>
  </div>
</div>